(function () {
  const DATA = window.HauschildWineBrainData || [];

  function wbTrack(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("event", eventName, params);
}

function wbGetSource() {
  const params = new URLSearchParams(window.location.search);
  return params.get("wb_source") || "direct";
}

  const STYLE_TARGETS = {
    fresh:   { ac: 4.2, bo: 1.8, fr: 3.2, oa: 0.3, mi: 2.8, ta: 0.8 },
    fruity:  { ac: 2.6, bo: 2.7, fr: 4.4, oa: 0.5, mi: 1.8, ta: 1.4 },
    mineral: { ac: 4.3, bo: 2.5, fr: 3.0, oa: 0.5, mi: 4.5, ta: 1.0 },
    power:   { ac: 2.8, bo: 4.5, fr: 4.0, oa: 3.0, mi: 2.0, ta: 3.3 },
    elegant: { ac: 3.5, bo: 3.0, fr: 3.5, oa: 1.5, mi: 3.2, ta: 2.0 }
  };

  const FOOD_TERMS = {
    fish: ["fisch", "meeresfrüchte", "sushi"],
    pasta: ["pasta", "pizza", "antipasti"],
    grill: ["grill", "fleisch", "bbq", "rind", "lamm", "wild"],
    veggie: ["salat", "gemüse", "vegetar", "spargel"],
    cheese: ["käse"]
  };

  const STYLE_LABELS = {
    fresh: "frisch & leicht",
    fruity: "fruchtig & weich",
    mineral: "mineralisch & präzise",
    power: "kräftig & voll",
    elegant: "elegant & fein"
  };

  function norm(v) {
    return (v || "").toString().toLowerCase();
  }

  function closeness(value, target) {
    return Math.max(0, 1 - Math.abs(Number(value || 0) - target) / 5);
  }

  function textHas(text, terms) {
    const hay = norm(text);
    return terms.some(term => hay.indexOf(term) !== -1);
  }

  function budgetAllows(price, budget, tolerance) {
    const p = Number(price || 0);
    const t = tolerance || 0;
    if (!budget || budget === "any") return true;
    if (budget === "u10") return p <= 10 + t;
    if (budget === "10-15") return p >= 10 - t && p <= 15 + t;
    if (budget === "15-25") return p >= 15 - t && p <= 25 + t;
    if (budget === "25-40") return p >= 25 - t && p <= 40 + t;
    if (budget === "40plus") return p >= 40 - t;
    return true;
  }

  function scoreProduct(p, answers) {
    if (!p || !p.h) return -9999;

    let score = 0;

    if (answers.type && answers.type !== "any") {
      if (p.ty !== answers.type) return -9999;
      score += 28;
    } else {
      score += 5;
    }

    if (!budgetAllows(p.p, answers.budget, 1.0)) return -9999;

    if (answers.sweetness === "dry") {
      if (Number(p.su) > 2.7) return -9999;
      score += closeness(p.su, 0.6) * 12;
      if (textHas(p.g, ["trocken", "brut", "nature", "extra brut"])) score += 8;
    } else if (answers.sweetness === "soft") {
      score += closeness(p.su, 2.0) * 12;
      if (textHas(p.g, ["feinherb", "halbtrocken", "demi-sec", "lieblich"])) score += 8;
      if (Number(p.ac) <= 3) score += 2;
    } else if (answers.sweetness === "sweet") {
      if (Number(p.su) < 2.5 && !textHas(p.g, ["süß", "lieblich", "doux", "dolce"])) return -9999;
      score += closeness(p.su, 4.2) * 15;
    } else {
      score += 3;
    }

    const target = STYLE_TARGETS[answers.style];
    if (target) {
      const weights = { ac: 4, bo: 4, fr: 4, oa: 2.5, mi: 3.5, ta: p.ty === "red" ? 2.5 : 1 };
      Object.keys(target).forEach(key => {
        score += closeness(p[key], target[key]) * weights[key];
      });

      const styleText = norm(p.st);
      const styleTerms = {
        fresh: ["frisch", "leicht", "schlank", "prickelnd"],
        fruity: ["fruchtig", "saftig", "weich", "rund"],
        mineral: ["mineralisch", "präzise", "straff"],
        power: ["kräftig", "würzig", "voll", "opulent"],
        elegant: ["elegant", "fein", "seidig", "balanciert"]
      };
      if (textHas(styleText, styleTerms[answers.style] || [])) score += 7;
    }

    const occasion = answers.occasion;
    if (occasion === "casual") {
      score += Number(p.cp || 0) * 2;
      if (textHas(p.oc, ["alltag", "terrasse"])) score += 8;
    } else if (occasion === "aperitif") {
      if (textHas(p.oc, ["aperitif", "feier", "party"])) score += 12;
      if (p.ty === "sparkling") score += 6;
      score += closeness(p.bo, 1.8) * 3;
    } else if (occasion === "gift") {
      score += Number(p.gi || 0) * 3;
      if (textHas(p.oc, ["geschenk", "besonderer anlass"])) score += 10;
      score += Number(p.fi || 0);
    } else if (FOOD_TERMS[occasion]) {
      if (textHas(p.fo, FOOD_TERMS[occasion])) score += 14;
      if (occasion === "fish" && ["white", "rose", "sparkling"].includes(p.ty)) score += 3;
      if (occasion === "grill") score += Number(p.bo || 0) * 1.2;
      if (occasion === "veggie") score += Number(p.ac || 0) * 0.7;
      if (occasion === "cheese") score += Number(p.bo || 0) * 0.8;
    }

    score += Number(p.cp || 0) * 0.55;
    score += Number(p.cf || 0) / 100 * 3;
    if (Number(p.hu || 0) === 1) score += 2;
    if (Number(p.q || 0) > 0) score += 2;

    return score;
  }

  async function fetchLiveProduct(handle) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = root + "products/" + encodeURIComponent(handle) + ".js";
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error("Produkt nicht verfügbar");
    return response.json();
  }

  function livePrice(product) {
    const availableVariants = (product.variants || []).filter(v => v.available);
    const cents = availableVariants.length
      ? Math.min.apply(null, availableVariants.map(v => Number(v.price || 0)))
      : Number(product.price || 0);
    return cents / 100;
  }

  function money(cents) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(Number(cents || 0) / 100);
  }

  function escapeHtml(str) {
    return (str || "").toString().replace(/[&<>"']/g, function (m) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[m];
    });
  }

  function rationale(meta, answers) {
    const parts = [];
    if (answers.style && STYLE_LABELS[answers.style]) parts.push(STYLE_LABELS[answers.style]);
    if (answers.sweetness === "dry") parts.push("trocken");
    if (meta.rec) return meta.rec;
    if (parts.length) return "Passt zu deiner Suche nach " + parts.join(", ") + ".";
    return "Passt sehr gut zu deinen Angaben.";
  }

  function selectDiverse(items, count, typeAnswer) {
    const selected = [];
    const usedVendors = new Set();
    const usedTypes = new Set();

    for (const item of items) {
      const vendorKey = norm(item.meta.v);
      const typeKey = item.meta.ty;
      const vendorFresh = !vendorKey || !usedVendors.has(vendorKey);
      const typeFresh = typeAnswer !== "any" || !usedTypes.has(typeKey);

      if (vendorFresh && typeFresh) {
        selected.push(item);
        if (vendorKey) usedVendors.add(vendorKey);
        usedTypes.add(typeKey);
      }
      if (selected.length >= count) return selected;
    }

    for (const item of items) {
      if (!selected.some(x => x.meta.h === item.meta.h)) {
        selected.push(item);
      }
      if (selected.length >= count) break;
    }
    return selected;
  }

  async function getResults(answers) {
    const ranked = DATA
      .map(p => ({ meta: p, score: scoreProduct(p, answers) }))
      .filter(x => x.score > -9000)
      .sort((a, b) => b.score - a.score)
      .slice(0, 36);

    const live = await Promise.all(ranked.map(async item => {
      try {
        const product = await fetchLiveProduct(item.meta.h);
if (!product || !product.available) return null;

    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || "").split(",");

    if (tags.some(tag => String(tag).trim().toLowerCase() === "ausschank")) {
      return null;
    }

    const price = livePrice(product);
    if (!budgetAllows(price, answers.budget, 0.01)) return null;

        return { ...item, product, livePrice: price };
      } catch (e) {
        return null;
      }
    }));

    const valid = live.filter(Boolean).sort((a, b) => b.score - a.score);
    return selectDiverse(valid, 3, answers.type);
  }

  function resultCard(item, rankLabel, buttonLabel) {
    const p = item.product;
    const meta = item.meta;
    const image = p.featured_image || (p.images && p.images[0]) || "";
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = root + "products/" + encodeURIComponent(meta.h);

    return `
      <article class="wbf-result-card">
        <a class="wbf-result-card__media" href="${url}">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ""}
        </a>
        <div class="wbf-result-card__body">
          <div class="wbf-result-card__match">${escapeHtml(rankLabel)}</div>
          ${meta.v ? `<div class="wbf-result-card__vendor">${escapeHtml(meta.v)}</div>` : ""}
          <h3 class="wbf-result-card__title"><a href="${url}">${escapeHtml(p.title)}</a></h3>
          <div class="wbf-result-card__price">${money(Math.round(item.livePrice * 100))}</div>
          <p class="wbf-result-card__why">${escapeHtml(rationale(meta, window.__wbfCurrentAnswers || {}))}</p>
          <a class="wbf-result-card__button" href="${url}">${escapeHtml(buttonLabel)}</a>
        </div>
      </article>
    `;
  }

  function initFinder(root) {
    if (!root || root.dataset.wbfReady === "true") return;
    root.dataset.wbfReady = "true";

    const steps = Array.from(root.querySelectorAll("[data-wbf-step]"));
    const progress = root.querySelector("[data-wbf-progress]");
    const progressText = root.querySelector("[data-wbf-progress-text]");
    const back = root.querySelector("[data-wbf-back]");
    const next = root.querySelector("[data-wbf-next]");
    const form = root.querySelector("[data-wbf-form]");
    const results = root.querySelector("[data-wbf-results]");
    const resultGrid = root.querySelector("[data-wbf-result-grid]");
    const resultMessage = root.querySelector("[data-wbf-result-message]");
    const restart = root.querySelector("[data-wbf-restart]");
    const buttonLabel = root.dataset.productButtonLabel || "Zum Wein";

    resultGrid.addEventListener("click", function (event) {
  const link = event.target.closest("a[href*='/products/']");
  if (!link || !resultGrid.contains(link)) return;

  const card = link.closest(".wbf-result-card");
  const cards = Array.from(resultGrid.querySelectorAll(".wbf-result-card"));
  const rank = card ? cards.indexOf(card) + 1 : 0;

  const url = new URL(link.href, window.location.origin);
  const productHandle = decodeURIComponent(
    (url.pathname.split("/products/")[1] || "").split("/")[0]
  );

  wbTrack("winebrain_finder_product_click", {
    product_handle: productHandle,
    rank: rank,
    wine_type: answers.type || "any",
    sweetness: answers.sweetness || "any",
    style: answers.style || "any",
    occasion: answers.occasion || "any",
    budget: answers.budget || "any",
    winebrain_source: wbGetSource(),
    page_path: window.location.pathname
  });
});

    let current = 0;
    let answers = {};
    let finderStarted = false;

    function activeChoice(step) {
      return step.querySelector(".wbf-choice.is-active");
    }

    function update() {
      steps.forEach((step, i) => {
        step.hidden = i !== current;
      });

      const pct = ((current + 1) / steps.length) * 100;
      if (progress) progress.style.width = pct + "%";
      if (progressText) progressText.textContent = (current + 1) + " / " + steps.length;

      back.disabled = current === 0;
      next.textContent = current === steps.length - 1
        ? (root.dataset.resultButtonLabel || "Zeig mir die Weine")
        : (root.dataset.nextLabel || "Weiter");

      const currentStep = steps[current];
      next.disabled = !activeChoice(currentStep);
    }

    root.addEventListener("click", function (event) {
  const choice = event.target.closest(".wbf-choice");
  if (choice && root.contains(choice)) {
    const step = choice.closest("[data-wbf-step]");
    if (!finderStarted) {
      finderStarted = true;
      wbTrack("winebrain_finder_start", {
        wine_type: choice.dataset.value || "unknown",
        winebrain_source: wbGetSource(),
        page_path: window.location.pathname
      });
    }
    step.querySelectorAll(".wbf-choice").forEach(x => x.classList.remove("is-active"));
    choice.classList.add("is-active");
    answers[step.dataset.question] = choice.dataset.value;
    update();
  }

});

    back.addEventListener("click", function () {
      if (current > 0) {
        current -= 1;
        update();
      }
    });

    next.addEventListener("click", async function () {
      const step = steps[current];
      const choice = activeChoice(step);
      if (!choice) return;

      answers[step.dataset.question] = choice.dataset.value;

      if (current < steps.length - 1) {
        current += 1;
        update();
        return;
      }

      next.disabled = true;
      next.classList.add("is-loading");
      const originalText = next.textContent;
      next.textContent = root.dataset.loadingLabel || "Wine Brain denkt …";

      try {
        window.__wbfCurrentAnswers = answers;
        const matches = await getResults(answers);

        form.hidden = true;
        results.hidden = false;

        if (matches.length) {
          const labels = [
            root.dataset.rankOne || "Dein stärkster Treffer",
            root.dataset.rankTwo || "Passt sehr gut",
            root.dataset.rankThree || "Auch spannend"
          ];
          resultGrid.innerHTML = matches.map((item, i) =>
            resultCard(item, labels[i] || labels[labels.length - 1], buttonLabel)
          ).join("");

          resultMessage.textContent = matches.length < 3
            ? "Aktuell haben wir weniger als drei passende verfügbare Flaschen gefunden."
            : "";
        } else {
          resultGrid.innerHTML = "";
          resultMessage.textContent = root.dataset.noResults || "Gerade ist kein passender Wein verfügbar. Versuch es mit einem anderen Budget oder einer offeneren Auswahl.";
        }

        results.scrollIntoView({ behavior: "smooth", block: "start" });

        const resultHandles = matches.map(x => x.meta.h);

        wbTrack("winebrain_finder_results", {
        wine_type: answers.type || "any",
        sweetness: answers.sweetness || "any",
        style: answers.style || "any",
        occasion: answers.occasion || "any",
        budget: answers.budget || "any",
        winebrain_source: wbGetSource(),
        result_count: resultHandles.length,
         result_1: resultHandles[0] || "",
        result_2: resultHandles[1] || "",
        result_3: resultHandles[2] || "",
       page_path: window.location.pathname
        });
      } catch (e) {
        resultMessage.textContent = "Da hat gerade etwas gehakt. Bitte versuch es noch einmal.";
      } finally {
        next.disabled = false;
        next.classList.remove("is-loading");
        next.textContent = originalText;
      }
    });

    restart.addEventListener("click", function () {
      answers = {};
      finderStarted = false;
      current = 0;
      steps.forEach(step => step.querySelectorAll(".wbf-choice").forEach(x => x.classList.remove("is-active")));
      results.hidden = true;
      form.hidden = false;
      resultGrid.innerHTML = "";
      resultMessage.textContent = "";
      update();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    update();
  }

  function boot() {
    document.querySelectorAll("[data-winebrain-finder]").forEach(initFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const finder = event.target.querySelector("[data-winebrain-finder]");
    if (finder) initFinder(finder);
  });
})();
